import { render, staticRenderFns } from "./OrbitAddProjectFormStep.vue?vue&type=template&id=33ad6416&scoped=true"
import script from "./OrbitAddProjectFormStep.vue?vue&type=script&lang=ts"
export * from "./OrbitAddProjectFormStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitAddProjectFormStep.vue?vue&type=style&index=0&id=33ad6416&prod&lang=scss&scoped=true"
import style1 from "./OrbitAddProjectFormStep.vue?vue&type=style&index=1&id=33ad6416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ad6416",
  null
  
)

export default component.exports